import styled from '@emotion/styled'

import OutputQuery from 'components/feature/NavigatorPanes/OutputNodePane/OutputQuery'

export const StyledOutputQuery = styled(OutputQuery)(
  () => `
    margin-top: 15px;
    .ant-select {
      width: 100%;
    }
  `
)
